import strip from "strip-markdown";
import { remark } from "remark";

export const stripMarkdown = (text: string): string | undefined => {
  let parsedText;
  remark()
    .use(strip)
    .process(text, (error, file) => {
      if (error) throw error;
      parsedText = String(file);
    });
  return parsedText;
};

const convertContentfulPropertiesToMarkdown = (
  properties: GatsbyTypes.AllContentfulApiReferenceContents_ContentfulProperties_Fragment
) =>
  `\n\n#### ${
    properties.title
  }\n\n<properties>\n${properties.json?.json?.substring(
    1,
    properties.json.json.length - 1
  )}\n</properties>\n\n`;

export const convertContentfulApiReferenceContentsToMarkdown = (
  content: GatsbyTypes.Maybe<
    | GatsbyTypes.AllContentfulApiReferenceContents_ContentfulMarkdown_Fragment
    | GatsbyTypes.AllContentfulApiReferenceContents_ContentfulProperties_Fragment
  >[]
): string =>
  content.reduce<string>((previousValue, currentValue) => {
    switch (currentValue?.__typename) {
      case "ContentfulMarkdown":
        return `${previousValue}\n\n${currentValue.childContentfulMarkdownBodyTextNode?.body}`;
      case "ContentfulProperties":
        return `${previousValue}${convertContentfulPropertiesToMarkdown(
          currentValue
        )}`;
      default:
        return previousValue;
    }
  }, "");
